import styled from "@emotion/styled";

// Table container
export const TableContainer = styled.div`
  overflow-x: auto;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
`;

export const StyledTable = styled.table`
  min-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
`;

export const TableHead = styled.thead`
  background-color: #f9fafb;
`;

export const HeaderCell = styled.th<{
  isFirst?: boolean;
  isGroupEnd?: boolean;
  darker?: boolean;
  guaranteeColor?: boolean;
  acceleratorColor?: boolean;
  isTotal?: boolean;
}>`
  padding: 0.75rem 0.5rem;
  text-align: left;
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: ${(props) =>
    props.guaranteeColor
      ? "#059669"
      : props.acceleratorColor
        ? "#9333ea"
        : props.darker
          ? "#374151"
          : "#6b7280"};
  background-color: ${(props) =>
    props.isTotal ? "#eff6ff" : props.isFirst ? "#f3f4f6" : "inherit"};
  border-right: ${(props) => (props.isGroupEnd ? "1px solid #d1d5db" : "none")};
  border-right: ${(props) => (props.isFirst ? "1px solid #d1d5db" : "")};
`;

export const TableRow = styled.tr<{
  isGuaranteeApplied?: boolean;
  isAcceleratorApplied?: boolean;
}>`
  background-color: ${(props) =>
    props.isGuaranteeApplied
      ? "#f0fdf4"
      : props.isAcceleratorApplied
        ? "#faf5ff"
        : "white"};
  border-bottom: 1px solid #e5e7eb;
`;

export const TableFooter = styled.tfoot`
  background-color: #f9fafb;

  tr {
    border-top: 2px solid #9ca3af;
  }
`;

const CellBase = styled.td`
  padding: 0.5rem;
  font-size: 0.875rem;
  white-space: nowrap;
`;

export const MonthCell = styled(CellBase)`
  border-right: 1px solid #d1d5db;
  background-color: #f3f4f6;
  font-weight: 500;
  color: #111827;
`;

export const DataCell = styled(CellBase)`
  color: #6b7280;
`;

export const DarkerCell = styled(CellBase)`
  color: #374151;
`;

export const GroupEndCell = styled(CellBase)`
  border-right: 1px solid #d1d5db;
  font-weight: 500;
  color: #6b7280;
`;

export const TotalPayCell = styled(CellBase)`
  border-right: 1px solid #d1d5db;
  background-color: #eff6ff;
  font-weight: 500;
  color: #111827;
`;

export const NetValueCell = styled(CellBase)<{ positive: boolean }>`
  font-weight: 500;
  color: ${(props) => (props.positive ? "#059669" : "#dc2626")};
`;

export const SubText = styled.div`
  font-size: 0.75rem;
  color: #9ca3af;
`;

export const QuotaSubText = styled.div`
  margin-top: 0.25rem;
  margin-left: 0.25rem;
  font-size: 0.75rem;
  color: #9ca3af;
`;

export const FooterCell = styled(CellBase)`
  font-weight: 700;
  color: #111827;
`;

export const FooterGroupEndCell = styled(FooterCell)`
  border-right: 1px solid #d1d5db;
`;

export const FooterMonthCell = styled(FooterCell)`
  border-right: 1px solid #d1d5db;
  background-color: #f3f4f6;
`;

export const FooterTotalCell = styled(FooterCell)`
  border-right: 1px solid #d1d5db;
  background-color: #eff6ff;
`;

export const FooterGuaranteeCell = styled(FooterCell)`
  color: #059669;
`;

export const FooterAcceleratorCell = styled(FooterCell)`
  color: #9333ea;
`;

export const FooterNetValueCell = styled(FooterCell)<{ positive: boolean }>`
  color: ${(props) => (props.positive ? "#059669" : "#dc2626")};
`;

export const FooterSubText = styled.div`
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: #6b7280;
`;

export const AcceleratorText = styled.span`
  cursor: help;
  font-weight: 500;
  color: #9333ea;
`;

export const GuaranteeText = styled.span`
  cursor: help;
  font-weight: 500;
  color: #059669;
`;

export const PlaceholderDash = styled.span`
  color: #9ca3af;
`;

export const TierIndicators = styled.div`
  margin-top: 0.25rem;
  margin-left: 0.25rem;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
`;

export const TierDot = styled.span<{ color: string }>`
  display: inline-block;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 9999px;
  background-color: ${(props) => props.color};
`;

export const ProgressBarContainer = styled.div`
  width: 4rem;
  height: 0.625rem;
  background-color: #e5e7eb;
  border-radius: 9999px;
  margin-right: 0.5rem;
`;

export const ProgressBar = styled.div<{ width: number; color: string }>`
  height: 0.625rem;
  width: ${(props) => props.width}%;
  background-color: ${(props) => props.color};
  border-radius: 9999px;
`;
